import { testMsg } from "../../test-apis";
import { isTestCompany } from "../../utils/auth";
import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 나의 회사 목록 조회
export const getMyCompanies = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/companies/my")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 회사 상세 조회
export const geCompany = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 회사 토큰 조회
export const getCompanyToken = ({ companyIdx, type }) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/${companyIdx}/token?type=${type}`)
      .then((res) => {
        const { companyToken } = res.data;
        localStorage.setItem("companyToken", companyToken);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록할 회사 조회
export const getCompanySearch = (data) => {
  return new Promise((resolve, reject) => {
    http
      .get("/companies/search", {
        params: data,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 등록 요청 회사 목록
export const getRequestCompanyList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/companies/request/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 등록 요청
export const requestCompany = (body) => {
  return new Promise((resolve, reject) => {

    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }
    http
      .post("/companies/request", body)
      .then((res) => {
        toast.success('신규 기업 등록이 완료되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 등록 요청
export const requestEmployees = (companyIdx) => {
  return new Promise((resolve, reject) => {

    if (isTestCompany()) {
      testMsg();
      reject();
      return;
    }

    http
      .post(`/companies/${companyIdx}/employees/request`)
      .then((res) => {
        toast.success('직원등록 요청이 완료되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 등록 요청 취소
export const cancelRequestEmployees = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/companies/${companyIdx}/employees/request`)
      .then((res) => {
        toast.success('직원등록 요청이 취소되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 등록 요청 취소
export const cancelRequestCompany = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/companies/request/${companyIdx}`)
      .then((res) => {
        toast.success('신규 기업 등록이 취소되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매니징 회사 관리 해제
export const deleteCareCompany = (
  companyIdx,
  params = {},
  message = "회사의 관리가 해제되었습니다."
) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/companies/${companyIdx}/care`, { data: params })
      .then((res) => {
        toast.success(message);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 나를 통한 회사 전체 조회 (throughTaxCompanyCode === 내 토큰코드)
export const getThroughMeCompanyAllList = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/companies/list", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createMasterPassword = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .post("/companies/master-password", { companyIdx })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateMasterPassword = (companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .put("/companies/master-password", { companyIdx })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const createBizCompany = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post("/companies/biz", params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCompanies = (params) => {
  return new Promise((resolve, reject) => {
    http
      .get("/companies", { params })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};